/* 🤖 this file was generated by svg-to-ts */
export const iconArrowGo: {
  name: 'arrow_go';
  data: string;
} = {
  name: 'arrow_go',
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15.928 8.36a.991.991 0 0 0 0-.72c-.017-.041-.042-.075-.063-.114-.028-.051-.046-.104-.083-.15l-4-5a1.002 1.002 0 0 0-1.407-.157c-.43.346-.501.975-.156 1.407L12.92 7H1a1 1 0 1 0 0 2h11.92l-2.701 3.375a1.002 1.002 0 0 0 .78 1.625c.294 0 .584-.13.783-.375l4-5c.037-.046.055-.101.083-.151.021-.04.046-.073.063-.115"/></svg>`,
};
